// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B209","top":"styles_top__3dzlv","left":"styles_left__3Wo8Z","description":"styles_description__3wiiA"};